import { AxiosPromise, AxiosRequestConfig } from "axios";
import { apis } from "service";
import { InvoiceDataResponse } from "../lib/types";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const get_customers = BASE_URL + 'FiAQK2sE/customer_via_number_v3'
const get_live_rates = BASE_URL + 'FiAQK2sE/fx_live_rates'
const create_order = BASE_URL + 'FiAQK2sE/create_order_forex_v3'
const calculation = BASE_URL + 'FiAQK2sE/forex_price_breakdown_portal_v3'
const get_address_by_id = BASE_URL + 'FiAQK2sE/fetch_address'
const add_contact = BASE_URL + `FiAQK2sE/add_contact_v3`
const get_country_list = `https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE/get-countries`
const Get_coupon = BASE_URL + `FiAQK2sE/getCoupon_v3`;
const APPLY_COUPON_ORDER = BASE_URL + `FiAQK2sE/apply_remove_coupon_v3`;
const get_invoice_data = 'https://automation.moneeflo.com/webhook/invoice_extract'
const apply_and_remove_coupon = `https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE/apply_remove_coupon_v3`
const send_ForexOrder_payment_Link = `https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE/share_payment_link_v3`
const Get_Order_Payment_status = `https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE/txn_detail_v3`
const add_currency_list = `https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE/forex_add_product_v3`
const generate_link = 'https://whale-app-bcwgq.ondigitalocean.app/api/link-generation-signzy'
const pan_verification = BASE_URL + 'FiAQK2sE/pan_extraction_v3_0'
const pan_update = BASE_URL + 'FiAQK2sE/pan_update_v3_0'
const passport_extraction = BASE_URL + 'FiAQK2sE/passport_extraction_v3_0'
const passport_update = BASE_URL + 'FiAQK2sE/passport_update_v3_0'

export interface CustomerResponse {
  phone_number: string;
  full_name: string;
  email: string;
  pan_no: string;
  id: number;
  kyc_status?: string;
}
export interface AddCurrencyParams {
  currency_have: string;
  currency_want: string;
  city_country: string;
  product_id: number;
  fx_amount: number;
  inr_amount: number;
  rate: number;
  customers_id: number;
}

// Update: AddCurrencyPayload expects product as an array
export interface AddCurrencyPayload {
  order_details_id: number;
  channels_id: number;
  branch: number;
  product: AddCurrencyParams[];
}


export interface CalculationPayload {
  amount: number;
  type: string;
}

export type ApplyCouponnOrderRequestType = {
  generic_order_details_id: number;
  discount_coupon_id: (string | number)[];
};


export interface CalculationResponse {
  amount: number;
  CGST: number;
  SGST: number;
  roundOff: number;
  service_charge: number;
  gst: {
    slab1: number;
    slab2: number;
    slab3: number;
    total_taxable_amount: number;
    gst: number;
  };
  total_payable: {
    grand_total: number;
  };
}

export interface CalculationPayload {
  amount: number;
  type: string;
}

export interface CalculationResponse {
  amount: number;
  CGST: number;
  SGST: number;
  IGST?: number;
  roundOff: number;
  service_charge: number;
  gst: {
    slab1: number;
    slab2: number;
    slab3: number;
    total_taxable_amount: number;
    gst: number;
  };
  total_payable: {
    grand_total: number;
  };
}


export interface sendPaymentLinkPayload {
  order_id: number;
  invoice_number: string;
  customers_id: number;
  type: string
}

export type OrderPayload = {
  invoice_uploaded?: boolean;
  invoice_abt?: number; // amount before tax
  invoice_grand_total?: number;
  invoice_gst?: number;
  invoice_sgst?: number;
  invoice_cgst?: number;
  invoice_igst?: number;
  invoice_service_charge?: number;
  invoice?: string; // base64 encoded string
  purpose: string;
  end_date: string; // ISO format e.g., "2025-05-23"
  start_date: string;
  type_of_order: "buy" | "sell";
  opportunity_id: number;
  discount_coupon_id: [
    any
  ];
  products: {
    customers_id: number | null;
    forex_type: "Sale" | "Purchase";
    currency_have: string;
    quantity: number;
    card_type: "multi currency" | "single currency";
    product_id: number;
    currency_want: string;
    rate: number;
    local_id: string; // new field added
    name?: string;
    pan_no?: string;
    phone_number?: string;
    email?: string;
  }[];
  delivery_details: Partial<{
    local_id: string[]; // links to one or more products
    customers_id: number;
    address_id: string; // UUID string
    delivery_mode: string;
    delivery_id: string;
    delivery_channel: string;
    address_line_1: string;
    address_line_2: string;
    city: string;
    state: string;
    pincode: string;
    country: string;
  }[]>;
};

export type CouponRemoveApply = {
  generic_order_details_id: number;
  discount_coupon_id: number[];
  amount: number;
  using_code: boolean;
};

export type PassportUpdateOrder = {
  passport_front: string;
  passport_back: string;
  customers_id: number;
  pan_name: string;
}

export const getCustomers = async (number: string): Promise<CustomerResponse[]> => {
  const payload: AxiosRequestConfig = {
    params: {
      number
    }
  }
  const response = await apis.get(get_customers, payload)
  return response.data as CustomerResponse[]
}

export const getLiveRates = async ({ currency, type, fx_product }: { currency: string, type: string, fx_product: string }): Promise<any> => {
  const payload: AxiosRequestConfig = {
    data: {
      currency: currency,
      type: type,
      fx_product: fx_product,
    },
  };
  const response = await apis.post(get_live_rates, payload)
  return response.data
}

// add Prodcut for Order 
export const addCurrency = async ({
  order_details_id,
  channels_id,
  branch,
  product, // array of AddCurrencyParams
}: AddCurrencyPayload): Promise<any> => {
  const payload: AxiosRequestConfig = {
    data: {
      order_details_id,
      channels_id,
      branch,
      product,
    },
  };

  const response = await apis.post(add_currency_list, payload);
  return response.data;
};

export const adddNewContact = async ({ name, pan_no, phone_number, email }: { name: string, pan_no: string, phone_number: string, email: string }): Promise<any> => {
  const payload: AxiosRequestConfig = {
    data: {
      name: name,
      pan_no: pan_no,
      phone_number: phone_number,
      email: email,
    },
  };
  const response = await apis.post(add_contact, payload)
  return response.data
}

export const createGenericOrder = async (data: OrderPayload): Promise<any> => {
  const payload: AxiosRequestConfig<OrderPayload> = {
    data: data
  }
  return await apis.post(create_order, payload)
}

export const applyandRemoveCouponOrder = async (data: CouponRemoveApply): Promise<any> => {
  const payload: AxiosRequestConfig<CouponRemoveApply> = {
    data: data
  }
  return await apis.post(apply_and_remove_coupon, payload)
}


export const getCalculations = async (data: CalculationPayload): Promise<CalculationResponse> => {
  const payload: AxiosRequestConfig<CalculationPayload> = {
    params: data
  }
  return (await apis.get(calculation, payload)).data
}

export const getAddressById = async (data: { customers_id: number }): Promise<{ address_id: { id: string }[] | any[] }> => {
  const payload: AxiosRequestConfig<{ customers_id: number }> = {
    params: data
  }
  return (await apis.get(get_address_by_id, payload)).data
}

export const getCountryList = async (): Promise<{
  name: {
    common: string;
    official: string;
  }
}[]> => {
  const response = await apis.get(get_country_list, {})
  return response.data
}

// Send PhoneOTP API
export type getCouponRequestType = Partial<{
  headers: { Authorization: string };
  params: {
    coupon_name: string;
  };
}>;

export type getCouponResponseType = Partial<{}>;
export const getCoupon = (
  config: AxiosRequestConfig<getCouponRequestType>
): AxiosPromise<getCouponResponseType> => apis.get(Get_coupon, config);


export type ApplyCouponOrderRequestType = Partial<{
  headers: { Authorization: string }
}>

export type applyCouponOrderResponseType = Partial<{}>

export const ApplyCouponOrder = (
  payload: AxiosRequestConfig<ApplyCouponOrderRequestType>,
): AxiosPromise<applyCouponOrderResponseType> => apis.post(APPLY_COUPON_ORDER, payload)

export const getInvoiceData = async (file: File): Promise<InvoiceDataResponse> => {
  const formData = new FormData()
  formData.append('data', file)
  const payload: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
      "Access-Control-Allow-Origin": "*",
    },
    data: formData
  }
  const response = await apis.post(get_invoice_data, payload)
  return response.data as InvoiceDataResponse
}

// send payment link 
export const sendPaymentLink = async (data: sendPaymentLinkPayload): Promise<any> => {
  const payload: AxiosRequestConfig<sendPaymentLinkPayload> = {
    data: data
  }
  return await apis.post(send_ForexOrder_payment_Link, payload)
}


// get txn status
export type getorderPaymentStatusRequestType = Partial<{
  headers: { Authorization: string };
  params: {
    invoice_number: string;
    type: string;
  };
}>;

export type getorderPaymentStatusResponseType = Partial<{}>;
export const getorderPaymentStatus = (
  config: AxiosRequestConfig<getorderPaymentStatusRequestType>
): AxiosPromise<getorderPaymentStatusResponseType> =>
  apis.get(Get_Order_Payment_status, config);

export const generateLink = async (data: { file: File, type: string }): Promise<any> => {
  const formData = new FormData()
  formData.append('file', data.file)
  const payload: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData
  }
  const response = await apis.post(generate_link, payload)
  return response.data
}

export const panVerification = async (data: { link: string }): Promise<any> => {
  const formData = new FormData()
  formData.append('pan_link', data.link)
  formData.append('type', 'individualPan')
  const payload: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData
  }
  const response = await apis.post(pan_verification, payload)
  return response.data
}

export const panUpdate = async (data: { customers_id: number, pan_no: string, pan_image: string, pan_name: string }): Promise<any> => {
  const formData = new FormData()
  formData.append('customers_id', data.customers_id.toString())
  formData.append('pan_no', data.pan_no)
  formData.append('pan_image', data.pan_image)
  formData.append('pan_name', data.pan_name)
  const payload: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData
  }
  const response = await apis.post(pan_update, payload)
  return response.data
}

export const passportExtraction = async (data: { linkFront: string, linkBack: string }): Promise<any> => {
  const payload: AxiosRequestConfig = {
    data: {
      "front_link": data.linkFront,
      "back_link": data.linkBack
    }
  }
  const response = await apis.post(passport_extraction, payload)
  return response.data
}
export const passportUpdateOrder = async (data: PassportUpdateOrder): Promise<{
  result1: string;
  addressID: string;
  kyc: string;
}> => {
  const formData = new FormData()
  formData.append('passport_front', data.passport_front)
  formData.append('passport_back', data.passport_back)
  formData.append('customers_id', data.customers_id.toString())
  formData.append('pan_name', data.pan_name)
  const payload: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData
  }
  const response = await apis.post(passport_update, payload)
  return response.data
}